export function validarTarifaMediaLiquida(tarifaMediaLiquida) {
    //se for maior que 6 tem dados inválidos no cálculo
    return parseFloat(tarifaMediaLiquida || 0) < 6;
}
